var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-area"},[_c('span',[_vm._v("您好，"+_vm._s(_vm.username))]),_c('span',{staticClass:"logout",on:{"click":_vm.logouthandle}},[_vm._v("退出")])])
}
var staticRenderFns = []

export { render, staticRenderFns }